/* Registers the service worker and offers a new build without applying it.
   Applying it reloads the page, which would drop whoever is partway through a
   queue, so the page only reloads after the operator asks for it. */

let applying = false;

export function registerServiceWorker({ onUpdateReady, onError }) {
  if (!('serviceWorker' in navigator)) return;

  const offer = worker => onUpdateReady(() => {
    applying = true;
    worker.postMessage({ type: 'SKIP_WAITING' });
  });

  navigator.serviceWorker.register('/sw.js').then(reg => {
    console.log('[sw] registered, scope:', reg.scope);
    if (reg.waiting && navigator.serviceWorker.controller) offer(reg.waiting);
    reg.addEventListener('updatefound', () => {
      const worker = reg.installing;
      worker.addEventListener('statechange', () => {
        if (worker.state !== 'installed') return;
        console.log('[sw] installed');
        if (navigator.serviceWorker.controller) offer(worker);
      });
    });
  }).catch(() => onError?.());

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (applying) location.reload();
  });
}
